<section [class]="!device().isParticipating ? 'inactive' : ''">
  <div class="status">
    <h6>{{ device().name }}</h6>
    @if (device().isOffline) {
      <mat-icon class="offline">wifi_off</mat-icon>
    } @else {
      <mat-icon class="online">wifi</mat-icon>
    }
    <app-status-indicator [status]="statusClass"></app-status-indicator>
  </div>
  <div class="device-info--container">
    <span class="body2">
      <b>Page refreshed:</b>
      {{ lastUpdateTime() | date: "HH:mm a, dd/MM/yy" }}
    </span>
    <div class="software--container">
      <div class="software-version">
        <span class="body2">
          <b>Installed software:</b>
          {{
            device().installedSoftwareVersion
              ? device().installedSoftwareVersion
              : "N/A"
          }}
        </span>
        @if (device().isUpToDate && device().installedSoftwareVersion) {
          <div class="software-tooltip" role="tooltip">
            <mat-icon class="valid">check_circle</mat-icon>
            <div class="top">
              Installed software was up to date when the experiment started.
              <i></i>
            </div>
            <div class="tooltip-accessibility">
              Installed software was up to date when the experiment started.
            </div>
          </div>
        }
        @if (!device().isUpToDate && device().installedSoftwareVersion) {
          <div class="software-tooltip" role="tooltip">
            <mat-icon class="invalid">warning</mat-icon>
            <div class="top">
              <p>
                Installed software was not up to date when the experiment
                started.
              </p>
              <i></i>
            </div>
            <div class="tooltip-accessibility">
              Installed software was not up to date when the experiment started.
            </div>
          </div>
        }
      </div>
      @if (!device().isUpToDate && device().installedSoftwareVersion) {
        <span class="body2"
          ><b>Current release:</b>
          {{
            device().latestSoftwareVersion ? device().latestSoftwareVersion : "N/A"
          }}</span
        >
      }
    </div>
    <app-basic-card
      fieldName="Ambient Temperature"
      [fieldReading]="experiment().ambientTemperature + '&deg;C'"
    ></app-basic-card>
    <!-- All experiments include optical density calibration -->
    <app-basic-card
      fieldName="Optical Density Calibration"
      [fieldReading]="device().calibration?.name"
    ></app-basic-card>
    @if (device().oxygenCalibration) {
      <app-basic-card
        fieldName="Oxygen Calibration"
        [fieldReading]="device().oxygenCalibration.name"
      ></app-basic-card>
    }
    @if (device().phCalibration) {
      <app-basic-card
        fieldName="pH Calibration"
        [fieldReading]="device().phCalibration.name"
      ></app-basic-card>
    }
    <app-icon-button
      [label]="
        device().deviceStatusId === DeviceStatus.Paused
          ? 'resume'
          : 'pause device'
      "
      buttonId="pause-btn"
      buttonStyle="pause"
      iconName="pause"
      [isDisabled]="buttonDisabled"
      (buttonClicked)="clickButton(device().id)"
    >
    </app-icon-button>
  </div>

  @if (device() && device().lastRead?.length > 0) {
    <div class="cards--container">
      @for (reading of device().lastRead; track reading) {
        <app-small-data-card
          [dataReading]="reading.value"
          [dataReadingTime]="reading.time"
          [temperatureReading]="reading.temperatureValue"
          [flask]="reading.name"
          [temperature]="
            experiment() ? experiment().ambientTemperature : undefined
          "
          [experiment]="experiment()"
        ></app-small-data-card>
      }
    </div>
  }
  @if (!device() || !(device().lastRead?.length > 0)) {
    <p class="body1 error">No data received</p>
  }
</section>
